import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Dialog from 'material-ui/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import Search from 'calcite-react/Search';
import IncidentLookupDetails from './IncidentLookupDetails';
import Select from '@mui/material/Select';
import Grid from '@mui/material/Grid';

class IncidentLookupDialog extends Component {

  constructor(props) {
    super(props);
    this.state =
    {
      isSearching: false,
      canSearch: false,
      searchIdentifer: null,
      searchValue: '',
      showSearchResults: false,
      searchResult: null
    };

    this.updateSearchValue = this.updateSearchValue.bind(this);
    this.onUserAction = this.onUserAction.bind(this)
  }

  onClose = () => {

    this.setState({
      isSearching: false,
      canSearch: false,
      searchIdentifer: null,
      searchValue: '',
      showSearchResults: false,
      searchResult: null
    });

    this.props.onClose();
  }

  onUserAction(value) {
    const searchEnabled = this.state.searchIdentifer !== null && (value !== null && value !== '');

    this.setState({
      searchValue: value,
      canSearch: searchEnabled
    });
  }

  updateSearchValue = (value) => {
    const searchEnabled = (this.state.searchIdentifer !== null && this.state.searchIdentifer !== '') && (value !== null && value !== '');

    this.setState({
      searchValue: value,
      canSearch: searchEnabled
    });
  }

  searchIncident = () => {
    window.api.incidentLookupSearch(this.state.searchValue, this.state.searchIdentifer).then((response) => {
      this.setState({
        showSearchResults: true,
        searchResult: response
      });
    });
  }

  updateIdentifier = (value) => {

    const searchEnabled = (this.state.searchValue !== null && this.state.searchValue !== '') && value !== null;
    this.setState({
      searchIdentifer: value,
      canSearch: searchEnabled
    });
  }

  render() {

    const spinner = (this.state.isSearching) ? (<CircularProgress size={24} thickness={2} />) : "";
    const actions = [
      <Button
        variant="text"
        primary={true}
        onClick={this.searchIncident}>Search</Button>,
      <Button
        variant="text"
        primary={true}
        onClick={this.onClose}>Close</Button>
    ];

    return (

      <Dialog
        open={this.props.open}
        modal={true}
        actions={actions}
        autoScrollBodyContent={true}
        contentStyle={{ width: '60%', height: '70%', maxWidth: 'none', overflowy: 'auto' }}>
        <Paper>
          <AppBar position="relative">
            <Toolbar variant="dense">
              <Typography variant="h6" color="inherit">
                Incident Lookup
              </Typography>

              <IconButton color="inherit" onClick={this.onClose} style={{ position: "relative", float: "right", }} aria-label="close">
                <CloseIcon />
              </IconButton>
            </Toolbar>

          </AppBar>
          <div>
            <Stack spacing={2} direction="row">
              <FormControl>
                <FormLabel id="demo-radio-buttons-group-label">Search by:</FormLabel>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  onChange={(event) => {
                    this.updateIdentifier(event.target.value);
                  }}>
                  <FormControlLabel value="UniqueFireIdentifier" control={<Radio />} label="Unique Fire Identifier" />
                  <FormControlLabel value="FORID" control={<Radio />} label="FORID" />
                  <FormControlLabel value="IRWINID" control={<Radio />} label="IRWIN ID" />
                  <FormControlLabel value="IncidentName" control={<Radio />} label="Incident Name" />
                </RadioGroup>
              </FormControl>
              <Stack spacing={2} direction="column" style={{ width: "650px", marginTop: "20px" }}>
                <Search fullWidth label="Identifier" onChange={this.updateSearchValue} inputValue={this.state.searchValue} onUserAction={this.onUserAction} />
                {this.state.searchIdentifer === "IncidentName" &&
                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} style={{ marginLeft: "-20px" }}>
                  <Grid item xs={4}>
                    <b>Calendar Year:</b>
                  </Grid>
                  <Grid item xs={8}>
                    <Select
                      native
                      defaultValue="2025">
                      <option value="2020">2020</option>
                      <option value="2021">2021</option>
                      <option value="2022">2022</option>
                      <option value="2023">2023</option>
                      <option value="2024">2024</option>
                      <option value="2025">2025</option>
                    </Select>
                  </Grid>
                  <Grid item xs={4}>
                    <b>State:</b>
                  </Grid>
                  <Grid item xs={8}>
                    <Select
                      native
                      id="demo-simple-select-helper">
                      <option aria-label="None" value="" />
                      <option value='AL'>Alabama</option>
                      <option value='AK'>Alaska</option>
                      <option value='AZ'>Arizona</option>
                      <option value='AR'>Arkansas</option>
                      <option value='CA'>California</option>
                      <option value='CO'>Colorado</option>
                      <option value='CT'>Connecticut</option>
                      <option value='DE'>Delaware</option>
                      <option value='FL'>Florida</option>
                      <option value='GA'>Georgia</option>
                      <option value='HI'>Hawaii</option>
                      <option value='ID'>Idaho</option>
                      <option value='IL'>Illinois</option>
                      <option value='IN'>Indiana</option>
                      <option value='IA'>Iowa</option>
                      <option value='KS'>Kansas</option>
                      <option value='KY'>Kentucky</option>
                      <option value='LA'>Louisiana</option>
                      <option value='ME'>Maine</option>
                      <option value='MD'>Maryland</option>
                      <option value='MA'>Massachusetts</option>
                      <option value='MI'>Michigan</option>
                      <option value='MN'>Minnesota</option>
                      <option value='MS'>Mississippi</option>
                      <option value='MO'>Missouri</option>
                      <option value='MT'>Montana</option>
                      <option value='NE'>Nebraska</option>
                      <option value='NV'>Nevada</option>
                      <option value='NH'>New Hampshire</option>
                      <option value='NJ'>New Jersey</option>
                      <option value='NM'>New Mexico</option>
                      <option value='NY'>New York</option>
                      <option value='NC'>North Carolina</option>
                      <option value='ND'>North Dakota</option>
                      <option value='OH'>Ohio</option>
                      <option value='OK'>Oklahoma</option>
                      <option value='OR'>Oregon</option>
                      <option value='PA'>Pennsylvania</option>
                      <option value='RI'>Rhode Island</option>
                      <option value='SC'>South Carolina</option>
                      <option value='SD'>South Dakota</option>
                      <option value='TN'>Tennessee</option>
                      <option value='TX'>Texas</option>
                      <option value='UT'>Utah</option>
                      <option value='VT'>Vermont</option>
                      <option value='VA'>Virginia</option>
                      <option value='WA'>Washington</option>
                      <option value='WV'>West Virginia</option>
                      <option value='WI'>Wisconsin</option>
                      <option value='WY'>Wyoming</option>
                      <option value='DC'>District of Columbia</option>
                      <option value='AS'>American Samoa</option>
                      <option value='GU'>Guam</option>
                      <option value='MP'>Northern Mariana Islands</option>
                      <option value='PR'>Puerto Rico</option>
                      <option value='UM'>United States Minor Outlying Islands</option>
                      <option value='VI'>Virgin Islands, U.S.</option>
                    </Select>
                  </Grid>
                </Grid> 
                }
              </Stack>


            </Stack>
            <Stack spacing={2} direction="row" style={{ marginLeft: "150px" }}>
              {spinner}
            </Stack>
            <IncidentLookupDetails visible={this.state.showSearchResults} searchResult={this.state.searchResult} reloadIncident={this.searchIncident} />
          </div>
        </Paper>
      </Dialog>
    );
  }
}
export default IncidentLookupDialog;
